<template>
    <div>
      <Header></Header>
      <div class="box">
      <div class="head-a">
        <img src="static/images/logo2.png" alt="">
      </div>
      <div class="content">
        <div>
          <h1>源代码说明</h1>
          <div style="font-size:18px;">
            <br>
            <Table border :columns="columns" :data="data"></Table>

            <h3>Python环境要求</h3>
            <div style="margin: 10px 0;">
              <List border>
                <ListItem >需要Python3
                </ListItem>
                <ListItem >需要Pandas模块
                </ListItem>
              </List>
            </div>
            <br>
            <h3>支付方式</h3>
            <h3>联系客服，沟通需求并确认费用</h3>
            <div style="text-align:center;">
              <img style="width:300px;height:300px;" src="https://cmshj.oss-cn-beijing.aliyuncs.com/data/qrcode.png" alt="">
            </div>
          </div>
        </div>
      </div>
      </div>
    </div>
</template>
<script>
import Header from './header'

export default {
  components: {
    Header
  },

  data () {
    return {
      columns: [
        {
          title: '名称',
          key: 'name'
        },
        {
          title: '说明',
          key: 'introduce'
        },
        {
          title: '价格',
          key: 'price'
        }
      ],
      data: [
        {
          name: '求月汇总.py',
          introduce: '按关键词+地区将数据做月汇总',
          price: '10元'
        },
        {
          name: '求月均值.py',
          introduce: '按关键词+地区将数据做月算数平均值',
          price: '10元'
        },
        {
          name: '求年汇总.py',
          introduce: '按关键词+地区将数据做年汇总',
          price: '10元'
        },
        {
          name: '求年均值.py',
          introduce: '按关键词+地区将数据做年算数平均值',
          price: '10元'
        },
        {
          name: '文件合并.py',
          introduce: '将多个结果文件直接拼接到一起',
          price: '10元'
        }
      ]
    }
  },
  mounted () {

  },
  methods: {
  }
}
</script>
<style lang="less" scoped>
@media (max-width: 768px){
  .box {
    width: 90vw !important;
  }
  .tx-box {
    margin: 0 !important;
  }
  .tb-box {
    margin: 40px 0 !important;
  }

}

a:hover {
  color: #177ff5;
}
// a:link{color: #177ff5;}
a:visited{color: #fff;}
.tao {
  color: #fff;
  background-color: #ec971f;
  border-color: #d58512;
  padding: 4px 8px;
  border-radius: 5px;
}
h3 {
  margin: 20px 0;
}
.box {
  margin: 60px auto;
  width: 60vw;
}
.head-a {
  background: #398dee;
  border-radius: 7px;
  padding: 20px;
}
.content {
  text-align: left;
  margin: 20px 0;
  padding: 20px;
}
.info {
  font-size: 18px;
  line-height: 34px;
  margin: 20px 0;
}
</style>



// WEBPACK FOOTER //
// src/components/intr_calc.vue